import React from 'react';
import { Empty, ErrorText, Panel, useChrome } from './ceoChrome';

const BOARDS = [
  { id: 'homeownersInvited', title: 'Homeowners invited' },
  { id: 'tasksCompleted', title: 'Tasks completed' },
  { id: 'aiUsage', title: 'AI questions' },
  { id: 'vendors', title: 'Vendor requests' },
];

export default function LeaderboardsPanel({ colors, narrow, data, error }) {
  const chrome = useChrome(colors, narrow);
  return (
    <div style={chrome.page} data-testid="ceo-leaders">
      <div>
        <h2 style={chrome.title}>Leaderboards</h2>
        <p style={chrome.sub}>Counts only. AI questions are a count. Chat text is not loaded.</p>
      </div>
      {error ? <ErrorText>{error}</ErrorText> : null}
      {!data && !error ? <Empty chrome={chrome}>Loading…</Empty> : null}
      <div style={{ display: 'grid', gridTemplateColumns: narrow ? '1fr' : '1fr 1fr', gap: 12 }}>
        {BOARDS.map((board) => {
          const rows = (data && data[board.id]) || [];
          return (
            <Panel key={board.id} chrome={chrome} title={board.title}>
              <h3 style={{ margin: '0 0 8px', fontSize: 17 }}>{board.title}</h3>
              {data && rows.length === 0 ? <Empty chrome={chrome}>No results yet.</Empty> : null}
              {rows.map((row) => (
                <div key={row.id || row.rank} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, minHeight: 44, alignItems: 'center', borderTop: `1px solid ${chrome.line}` }}>
                  <span style={{ minWidth: 0 }}>{row.rank}. {row.name}</span>
                  <span style={{ fontWeight: 600 }}>{row.count}</span>
                </div>
              ))}
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
